import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-animate_view_active",
  "use": "icon-animate_view_active-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-animate_view_active\">\n    <rect width=\"32\" height=\"32\" rx=\"6\" fill=\"#3663E1\" />\n    <path d=\"M12.5081 22L23.232 15.8858C23.5698 15.6932 23.5682 15.2057 23.2291 15.0154L12.5081 9\" stroke=\"#fff\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n    </symbol>"
});
var result = sprite.add(symbol);
export default symbol